forms-orders-under
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="forms_orders_under.inputs.method")
    inputs-hidden(tag-scope="forms_orders_under.inputs.authenticity_token")
    inputs-complex-radio-under(tag-scope="forms_orders_under.inputs.under" label="{this.opts.inputs.under.label}" items="{this.opts.inputs.under.items}" name="{this.opts.inputs.under.name}" value="{this.opts.inputs.under.value}")
    input(type="hidden" name="refresh" value="{opts.refresh}")
    inputs-submit(tag-scope="forms_orders_under.inputs.submit")
  script(type="typescript").
    this.mixin('forms.orders.under');
